import React from "react";
import { ContainerModal } from "../container/ContainerModal";

export const ModalDebugTaskCount = ({ taskList = {}, closeModalDetails }) => {

	return (
		<div className="fixed top-0 left-0 w-full h-full z-50 bg-black bg-opacity-45 flex justify-center items-center">
			<ContainerModal
				title={"Modal Debug"}
				actionButton={() => {
					closeModalDetails();
				}}
				className={"w-[500px]"}
			>
				<div className="grid grid-cols-2 w-full">
					<p>Area </p>
					<p>Cantidad de tareas</p>
				</div>
				<div className="h-[2px] w-full bg-black" />
				{Object.entries(taskList).map(([key, value], index) => (
					<div key={`${index}-task-debug`} className="grid grid-cols-2 w-full">
						<span className="font-semibold capitalize">{key}: </span>
						<span>{value}</span>
					</div>
				))}
			</ContainerModal>
		</div>
	);
};
